import { ReactElement } from "react";
import styled from "styled-components";
import { h } from "../../h";
import { Items } from "./Items";

const MainStyled = styled.div`
    margin-top: 46px;
`;

export const Main = (): ReactElement => {
    return h(MainStyled, {}, h(Items));
};
